import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssociateVendorsComponent } from './associate-vendors.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  declarations: [AssociateVendorsComponent],
  imports: [
    SkeletonLoaderModule,
    CommonModule,
    FormsModule,
    PipesModule
  ],
  entryComponents: [AssociateVendorsComponent],
  exports: [AssociateVendorsComponent]
})
export class AssociateVendorsModule { }
